/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum JiraDataCenterPolicyDescriptionAttribute {
    classification = 'classification',
    content_type = 'content_type',
    created_at = 'created_at',
    created_by = 'created_by',
    display_name = 'display_name',
    engine_type = 'engine_type',
    operating_system = 'operating_system',
    policy_id = 'policy_id',
    policy_type = 'policy_type',
    resources = 'resources',
    services = 'services',
    severity = 'severity',
    status = 'status',
    sub_classification = 'sub_classification',
    updated_at = 'updated_at',
    updated_by = 'updated_by',
    uri = 'uri'
}
